import React from 'react';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import './Legal.css';

const TermsConditions = () => (
  <div className="legal-page">
    <Header />
    <div className="legal-hero">
      <h1>Terms & Conditions</h1>
      <p>Last updated: 02 - May - 2026</p>
    </div>
    <div className="legal-content">
      <section>
        <h2>1. Acceptance of Terms</h2>
        <p>By accessing and using the Musa Electrical website, you agree to be bound by these Terms & Conditions.</p>
      </section>
      <section>
        <h2>2. Services</h2>
        <p>Musa Electrical provides electrical installation, CCTV & alarms, solar systems, network installation, electrical designs, electric fence, TV installation, and electronics repair services. All services are subject to availability and location.</p>
      </section>
      <section>
        <h2>3. Quotes & Pricing</h2>
        <p>All quotes provided are estimates based on initial assessment. Final pricing may vary depending on the scope of work, materials required, and site conditions. A detailed quote will be provided before work commences.</p>
      </section>
      <section>
        <h2>4. Payment Terms</h2>
        <p>Payment is due upon completion of work unless otherwise agreed. We accept M-Pesa, bank transfers, cash, and cheque payments. For large projects, milestone-based payment plans are available.</p>
      </section>
      <section>
        <h2>5. Warranty</h2>
        <p>We provide warranty on workmanship for all installations. Manufacturer warranties apply to all products and equipment supplied. Warranty periods vary by service type.</p>
      </section>
      <section>
        <h2>6. Liability</h2>
        <p>Musa Electrical is fully insured. We follow strict safety standards and building codes. Liability is limited to the value of the services provided.</p>
      </section>
      <section>
        <h2>7. Contact</h2>
        <p>For questions about these terms, contact <a href="mailto:info@musaelectricalkenya.co.ke">info@musaelectricalkenya.co.ke</a> or call <a href="tel:0796049254">0796049254</a>.</p>
      </section>
    </div>
    <Footer />
  </div>
);

export default TermsConditions;
